import { Transition } from "../../../core/flows/Transition";
import { SearchContext } from "../../Common/Search/Context/SearchContext";
import { SelectOfferContext } from "../../TrainOfferPage/SelectOfferFlow/Context/SelectOfferContext";
import { TicketOptionContext } from "../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";
import { MainBookingContext } from "../Context/MainBookingContext";

export class MainBookingSearchTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {

        const context = this.getCtx<SearchContext>("searchContext", this.entryStep)!;

        const selectOfferContext = new SelectOfferContext()
        this.setCtx<SelectOfferContext>("SelectOfferContext", selectOfferContext, this.entryStep)

        const ticketOptionContext = new TicketOptionContext()
        this.setCtx<TicketOptionContext>("ticketOptionContext", ticketOptionContext, this.entryStep);

        if (context.nextTo.includes("FmlmViewFlow")){
            // Exit flow if FmlmViewFlow is next
            console.log("[Transition] FmlmViewFlow is next, exiting MainBookingFlow");
            return []
        } else if (context.nextTo.includes("SelectOfferFlow")) {
            context.routeTo = context.nextTo
            context.nextTo = []
        } else {
            context.routeTo = ["SelectOfferFlow", "TicketOptionFlow"]
        }

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }
        return [...(context?.routeTo ?? [])]
    }

}